export default __webpack_public_path__ + "static/media/logo.86305f74.png";